import { Injectable } from '@angular/core';
import { DEFAULT_LOCALE } from '@config/global-constants';
import { ILocales } from '@app/i18n/i18n.types';
import { get, includes, isEqual, merge } from 'lodash';
import { environment } from '@environments/environment';

/**
 * LocaleService - A standalone service to manage locale information
 * This service acts as a bridge to avoid circular dependencies between
 * I18nService and TranslationService
 */
@Injectable({ providedIn: 'root' })
export class LocaleService {
  protected locale: ILocales;

  public get defaultLocale(): string {
    const devAppLocale = get(environment, 'DEV_APP_LOCALE', '');
    const defaultLocale = !includes(['undefined', ''], devAppLocale)
      ? devAppLocale
      : DEFAULT_LOCALE;

    return defaultLocale;
  }

  public get userLocale(): string {
    return get(this.locale, 'userLocale', this.defaultLocale);
  }

  public constructor() {}

  /**
   * Set the current locale
   */
  public setLocale(locale: ILocales): void {
    this.locale = locale;
  }

  /**
   * Get the current locale information
   */
  public getLocale(): ILocales {
    return merge(
      {
        userLocale: this.userLocale,
      },
      this.locale,
    );
  }

  /**
   * Check if user-defined translation is needed
   * Returns true if current locale is different from default locale
   */
  public isNeedUserDefinedTranslate(): boolean {
    return !isEqual(DEFAULT_LOCALE, this.userLocale);
  }
}
